export default theme => ({
    ciro: {
        display: 'flex',
        paddingBottom: '15px'
    },
    ciroLogo: {
        marginBottom: '10px'
    },
    footer: {
        display: 'flex',
        justifyContent: 'center',
        padding: '32px 0 75px 0',
        width: '100%'
    },
    footerRoot: {
        fontFamily: 'Proxima-Nova, sans-serif',
        justifyContent: 'flex-start',
        lineHeight: '20px'
    },
    innerOr: {
        background: '#ffffff',
        color: '#333333',
        fontFamily: 'Proxima-Nova, sans-serif',
        fontSize: '14px',
        lineHeight: '20px',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '-10px',
        textAlign: 'center',
        width: '35px'
    },
    link: {
        '&[disabled]': {
            cursor: 'default',
            pointerEvents: 'none'
        },
        color: 'rgb(0, 81, 165)',
        fontSize: '14px',
        letterSpacing: '0',
        lineHeight: '20px'
    },
    linkContainer: {
        '& > a': {
            '@media screen and (max-width: 320px)': {
                display: 'block'
            },
            paddingRight: '13px'
        },
        letterSpacing: '0',
        lineHeight: '16px',
        marginBottom: '20px'
    },
    orDivider: {
        borderTop: '1px solid #dadada',
        lineHeight: '20px',
        margin: '11px 0 10px 0',
        textAlign: 'center',
        width: '100%'
    },
    text: {
        color: '#333333',
        fontFamily: 'Proxima-Nova, sans-serif',
        fontSize: '13px',
        lineHeight: '1.5'
    },
    textSub: {
        color: '#333333',
        fontFamily: 'Proxima-Nova, sans-serif',
        fontSize: '16px',
        lineHeight: '1.5'
    },
    verbiageContainer: {
        color: 'rgba(0,0,0,0.54)',
        display: 'flex',
        fontSize: '14px',
        fontWeight: '400',
        letterSpacing: '0',
        lineHeight: '1.5',
        margin: '0 auto',
        marginBottom: '20px'
    }
})
